export const usersDriverColumns = [
  {
    column_name: 'ID',
    column_value: 'id',
  },
  {
    column_name: 'Name',
    column_value: 'full_name',
  },
  {
    column_name: 'Mobile No.',
    column_value: 'mobiles',
  },
  {
    column_name: 'Driver\'s License',
    column_value: 'license_number',
  },
  {
    column_name: 'Landline No.',
    column_value: 'landlines',
  },
  {
    column_name: 'Email Address',
    column_value: 'email',
  },
  {
    column_name: 'Designation',
    column_value: 'designation',
  },
  {
    column_name: 'Doc. Verification',
    column_value: 'is_docs_verified',
  },
  {
    column_name: 'Status',
    column_value: 'is_active',
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: '',
    column_value: '',
  },
]

export const driverInfo = reactive({
  address: '',
  designation: '',
  email: null,
  fullName: null,
  landlines: [],
  license_number: '',
  mobiles: [],
})

export const driverSearchFields: any = reactive({
  id: '',
  fullname: '',
  mobiles: '',
  landlines: '',
  email: '',
  designation: '',
  is_docs_verified: null,
  is_active: null,
  license_number: null,
})

export const resetDriverFields = { ...driverSearchFields }
